module.exports = __webpack_public_path__ + "07e296dfb483c2172b7e54629aea44b2.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-872.webp
// module id = 233
// module chunks = 0